// const END_POINT = "http://10.0.0.182:8087";
const END_POINT = "https://iot-api.horwincloud.com";

// const END_POINT = "http://iot-api.hw.innotick.com";
const OSS_POINT = "https://horwin-ota.oss-cn-hangzhou.aliyuncs.com";

const Const = {
    NET: {
        END_POINT,

        OTA_FILE_UPLOAD_END_POINT: `${END_POINT}/file/ota-file-upload`,
        FILE_URL_PREFIX: `${OSS_POINT}/`,
    },

    DATA: {
        KEY_PREFIX: "horwin.iot.admin.data.",
        KEY_TOKEN: "token",
        KEY_USER: "user",
        KEY_USER_TYPE: "user.type",
        KEY_AUTHORITY: "authority",
        KEY_LANGUAGE: "language",
    },
    USER: {
        TYPE: {
            CLIENT: 1,
            ADMIN: 2,
        },
        TYPE_MAP: {
            '1': { value: 1, key: 'user.client', label: '普通用户' },
            '2': { value: 2, key: 'user.admin',  label: '管理员' },
        }
    },

    OTA_TASK: {
        STATUS: {
            INIT: 100,
            UPGRADE: 200,
            PAUSE: 300,
            SUCCESS: 400,
            FAIL: -100,
        },
        STATUS_MAP: {
            "0":    { value: 0,   key: 'task.status.init', label: "初始化", color: 'gray' },
            "100":  { value: 100, key: 'task.status.init', label: "初始化", color: 'gray' },
            "200":  { value: 200, key: 'task.status.upgrading', label: "升级中", color: 'green' },
            "300":  { value: 300, key: 'task.status.paused', label: "暂停", color: 'yellow' },
            "400":  { value: 400, key: 'task.status.finish', label: "完成", color: 'blue' },
            "-100": { value:-100, key: 'task.status.stop', label: "停止", color: 'orange' },
        },
        MEMBER_STATUS_MAP: {
            "100":  { value: 100, key: 'task.member_status.init', label: "初始化" },
            "200":  { value: 200, key: 'task.member_status.in_preparation', label: "准备中" },
            "300":  { value: 300, key: 'task.member_status.upgrading', label: "升级中" },
            "400":  { value: 400, key: 'task.member_status.success', label: "成功" },
            "-100": { value:-100, key: 'task.member_status.failure', label: "失败" },
            "-201": { value:-201, key: 'task.member_status.fail_in_get_file', label: "获取升级文件信息失败" },
            "-202": { value:-202, key: 'task.member_status.fail_in_set_file', label: "本地暂存升级文件失败" },
            "-301": { value:-301, key: 'task.member_status.fail_in_get_data', label: "获取分片数据失败" },
        },
        UPGRADE_STATUS_MAP: {
            "0": { label: "空闲",   key: 'task.upgrade_status.leisure'},
            "1": { label: "升级中", key: 'task.upgrade_status.upgrading'},
        },

        TARGET_TYPE: {
            "DTU": 0,
            "BMS": 1,
        },
        TARGET_TYPE_MAP: {
            "0": { value: 0, key: 'device.DTU', label: "DTU" },
            "1": { value: 1, key: 'device.BMS', label: "BMS" },
        }
    },

    DEVICE: {
        STATUS: {
            ONLINE: 1,
            OFFLINE: 0,
        },
        STATUS_MAP: {
            '1': { value: 1, label: "在线", key: 'device.status.online',  class: "online" },
            '0': { value: 0, label: "离线", key: 'device.status.offline', class: "offline" },
        },
        STATUS_LIST: [
            { value: '',label: "全部", key: 'device.status.all' },
            { value: 1, label: "在线", key: 'device.status.online' },
            { value: 0, label: "离线", key: 'device.status.offline' },
        ],

        SPACE: {
            JIAWEI: 26001,
            LIERDA: 26003,
            BMS_26005: 26005,
            BMS_26006: 26006,
        },
        SPACE_MARK: {
            BMS: [26005, 26006]
        },
        SPACE_MAP: {
            "26001": { value: 26001, key: 'device.space.26001', label: "车辆-26001" },
            "26003": { value: 26003, key: 'device.space.26003', label: "车辆-26003" },
            "26004": { value: 26004, key: 'device.space.26004', label: "车辆-26004" },
            "26007": { value: 26007, key: 'device.space.26007', label: "车辆-26007" },
            "26005": { value: 26005, key: 'device.space.26005', label: "BMS-26005" },
            "26006": { value: 26006, key: 'device.space.26006', label: "BMS-26006" },
        },
    },

    COMMAND: {
        STATUS: {
            WAIT: 0, // 等待中
            ISSUED: 100, // 已下发
            RESPOND: 200, // 已回应
            FAILURE: -100, // 已失败
        },
        STATUS_MAP: {
            "0":   { value: 0,   label: "等待中", key: 'command.status.wait' },
            "100": { value: 100, label: "已下发", key: 'command.status.issued' },
            "200": { value: 200, label: "已回应", key: 'command.status.respond' },
            "-100":{ value:-100, label: "已失败", key: 'command.status.failure' },
        },

        TYPE_MAP: {
            0x01: { key: 'command.type.0x01', label: '下发配置' },
            0x02: { key: 'command.type.0x02', label: '获取节点状态' },
            0x03: { key: 'command.type.0x03', label: '获取节点配置' },
            0x04: { key: 'command.type.0x04', label: '设置参数' },
            0x05: { key: 'command.type.0x05', label: '设置插座系统参数' },
            0x06: { key: 'command.type.0x06', label: '控制' },
            0x07: { key: 'command.type.0x07', label: '组网' },
            0x08: { key: 'command.type.0x08', label: '添加节点' },
            0x09: { key: 'command.type.0x09', label: '删除节点' },
            0x0A: { key: 'command.type.0x0A', label: '升级' },
            0x0B: { key: 'command.type.0x0B', label: '刷卡充电控制' },
            0x0C: { key: 'command.type.0x0C', label: '查询刷卡余额回应' },
            0x0D: { key: 'command.type.0x0D', label: '设置语音播报配置' },
            0x31: { key: 'command.type.0x31', label: '刷卡充电开始回应' },
            0x32: { key: 'command.type.0x32', label: '刷卡充电结束回应' },
        },

    },
    REQUEST: {
        DATA_TYPE_MAP: {
            "EVENT_PLUG_HEARTBEAT":    { label: "插座心跳", key: 'command.request_data_type.plug_heartbeat'},
            "EVENT_CHARGE_FINISHED":   { label: "充电结束", key: 'command.request_data_type.charge_finished'},
            "EVENT_GATEWAY_HEARTBEAT": { label: "网关心跳", key: 'command.request_data_type.gateway_heartbeat'},
            "EVENT_PLUG_MP_HEARTBEAT": { label: "多口插座心跳", key: 'command.request_data_type.plug_mp_heartbeat'},
            "EVENT_CHARGE_FINISHED_3": { label: "分功率充电结束", key: 'command.request_data_type.charge_finished_3'},
            "EVENT_CARD_CHARGE_STARTED":  { label: "刷卡充电开始", key: 'command.request_data_type.card_charge_started'},
            "EVENT_CARD_CHARGE_FINISHED": { label: "刷卡充电结束", key: 'command.request_data_type.card_charge_finished'},
        }
    },

    EVENT: {
        TYPE_MAP: {
            "1": { value: 1, label: "连接", key: 'event.type.connect', color: "blue" },
            "2": { value: 2, label: "断开", key: 'event.type.break',   color: "red"  },
        },
    }
}

export default Const

